import { Component, OnInit } from '@angular/core';
import { LoadingAndErrors } from '../../../../classes';
import { BsModalRef } from 'ngx-bootstrap';
import { ProductsService } from '../../../../services';
import { LoopBackAuth, DiscountLimitApi } from '../../../../../assets/js/lb-sdk';
import { finalize } from 'rxjs/operators';

interface DiscountLimitForm {
  id?: string,
  productType: { id: string, name: string },
  discount: number
}

@Component({
  selector: 'app-discount-limit-form',
  templateUrl: './discount-limit-form.component.html',
  styleUrls: ['./discount-limit-form.component.css']
})
export class DiscountLimitFormComponent implements OnInit {
  data: DiscountLimitForm;
  error: string;
  loading: boolean;

  constructor(
    public modal: BsModalRef,
    public productService: ProductsService,
    private discountLimitApi: DiscountLimitApi
  ) { }

  ngOnInit() {
    this.data = this.data || {
      productType: undefined,
      discount: 0
    };
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    if (form.valid) {
      const {
        id,
        productType,
        discount
      } = this.data;
      this.error = undefined;
      this.loading = true;
      (id ?
        this.discountLimitApi
          .patchAttributes(id, {
            value: discount
          }) :
        this.discountLimitApi
          .create({
            productType: productType.name,
            value: discount
          })
      ).pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(response => {
        this.modal.content.result = response;
        this.modal.hide();
      }, error => {
        if (error && error.message) {
          this.error = error.message.indexOf('ER_DUP_ENTRY') >= 0 ?
            'Already have a discount limit for the specified product.' :
            'Failed to create discount limit.';
        } else {
          this.error = 'Failed to create discount limit.';
        }
      });
    }
  }

}
